//import s from './style.module.scss';
import ep from './ep.module.scss';
import tac from './tac.module.scss';
//ep.module.scss
import {logout} from '../../../components/dropdown';
import {wpUser,production} from '../../../../k';
//import Input2 from '../../../components/input2';
//import Input1 from '../../../components/input';
import { useRef, useState, useEffect } from 'react';
import SubmitBtn from '../../../components/submit';
import { loaderPostFetch } from '../util';
import SendNotice from '../../../components/sendnotice'; 

import PinInput from "react-pin-input";
import { useActionData, useSubmit, useLocation,useNavigate } from 'react-router-dom';

//import Card, { Card2 } from '../../../components/card';
//import TextAr from '../../../components/textarea';

//TransferSubmitted

//import TransferSubmitted from '../w19f/submitted'; 

import Notif from '../../../components/notif';
import { Outlet, Link, useLoaderData, Form } from 'react-router-dom';

export async function epaction({ request, params }) {
  const formData = await request.formData();
  let nformData = new FormData(); 
  let tok = window.localStorage.getItem('sbaUid');
  if (tok != null) {
    nformData.append('token', tok);
  } 
  const contact = await loaderPostFetch(`api/users.php`, nformData);
  //return contact;
  return {...contact};
 
}

export async function eploader({ params }) {

  const formData = new FormData();
  formData.append('getpinfunc', 'getpinfunc');

  let tok = window.localStorage.getItem('sbaUid');
  if (tok != null) {
    formData.append('token', tok);
  }
  const perc2 = await loaderPostFetch(`api/users.php`, formData);
   
  return { ...params, ...perc2 };
}

export default function EnterPin() { 
  const submit = useSubmit();
  
  //const { perc, trx_notif } = useLoaderData();
  const navigate = useNavigate();

  const {trx_notif} = useLoaderData();


  let actionData = useActionData();

  const [n, sN] = useState({ display: false, type: 'success', msg: '' });
const [no, sNo] = useState(false);

 


  const [showDone, sshowDone] = useState(false);
  useEffect(() => {

    if (actionData) {
      let s = actionData;
      console.log(s);
      if (s?.icon) {
        if (s?.icon=="success") {
          //sshowDone(true);
          sN({ ...n, type: 'success', msg: s?.message });
          setTimeout(() => {window.location.href = `../../dashboard`;}, 3000);
        } else {
          //sNo(s?.trx_notif);
          sN({ ...n, type: 'error', msg: s?.message });
        }
      }
      
      setTimeout(() => {
        sN({ display: false, type: 'success', msg: `` });
      }, 2000);
      
    }
  }, [actionData]);
 

  let ele = useRef();

  let ele2 = useRef();

  const [tpc, setTpc] = useState(true);

  const [pin, setPin] = useState("");

  const [he, setHe] = useState(false);
  const [bo, setBo] = useState(false);



  useEffect(()=>{
    if(trx_notif){

    let b=trx_notif[0];
    console.log(b);
      
        setHe(b?.head);
        setBo(b?.body);
    }
  },[trx_notif]);

  const handlePinComplete = (value) => {
    
    setPin(value); 
  };

  const handlePinComplete2 = (value) => {
    
    setPin(value); 
  };

  const sbtnref = useRef();
 

  const confirmtranspin=()=>{
    if (typeof pin=="undefined") {
      sN({ display: true, type: 'error', msg: 'Invalid Pin' }); 
    }else{
      const formData = new FormData();

      let tok = window.localStorage.getItem('sbaUid');
      if (tok != null) {
        formData.append('pin', pin);
        formData.append('token', tok);
        formData.append('verifypinfunc', 'verifypinfunc');
        loaderPostFetch(`api/users.php`, formData).then((b)=>{

          if (b?.status) {
            sN({ display: true, type: 'success', msg: 'Action Successful!' });
            //ele.clear();
            
            //submit(sbtnref.current);

            //correct location for auth token
              window.localStorage.setItem("baUid", tok);

            setTimeout(()=>{ 
              window.location.href = '/wp-user/dashboard';

            },5000);
            
          }else{
            sN({ display: true, type: 'error', msg: b?.message });
            ele.clear();
            setPin(undefined);

          }
      
        }).catch((e)=>{

          sN({ display: true, type: 'error', msg: 'An error has Occured.' });
          ele.clear();
          setPin(undefined);
      
        });

      }
    }

    setTimeout(() => {
      sN({ display: false, type: 'success', msg: `` }); 
    }, 15000);

  }
  

  return (
    <>

    <div className={tac.topq}>

      <div className={tac.img}> 
          <img src={`${wpUser}/b/logo.png`} onClick={() => {
          //window.location.href = `${wpUser}/account/`; 
          window.location.href = `${wpUser}`; 
        }} />
      </div>

      <button className={tac.btn3} onClick={() => {
          logout();
          window.location.href = `${wpUser}`;
        }}>
      logout
      </button>

    </div>

      <Notif display={n?.display} type={n?.type} msg={n?.msg} />

      {showDone?<></>:<>
 
      {no?<SendNotice display={true} 
        t={no?.[0]?.title} 
        b={no?.[0]?.body} />:null}

      <div>
        <div  style={{ marginBottom: '1rem' }}>
            
        </div>


            {(tpc) ?
              <div className={tac.tac}>
        <div className={tac.card}>
          <div className={tac.icon}></div>
          <div className={tac.hea} style={{'whiteSpace': 'pre-line','padding':'0px 1.5rem'}}>{he?he:'Transfer Authorization Code is required'}</div>

          <PinInput
            ref={(n) => (ele = n)} /*Set ref */
            onComplete={handlePinComplete}
            length={4}
            focus
            inputMode="number"
            secret
            secretDelay={500}
            inputStyle={{
              border: "2px solid #3498db", // Customize the border color
              borderRadius: "8px", // Adjust border radius
              fontSize: "14px", // Change font size
              fontStyle: "normal",
              fontFamily: "Inter",
              fontWeight: "500",
              padding: "5px", // Add some padding
              margin: "5px", // Adjust margin
            }}
            inputFocusStyle={{ borderColor: "lightgray" }}
          />

          <div className={tac.btn} onClick={confirmtranspin}>Confirm</div>

          <div className={tac.txt} style={{'whiteSpace': 'pre-line','padding':'0px 1.5rem'}}>
          {bo?bo:''} </div>


           {/*<div className={tac.btn} 
           onClick={() => {
          logout();
          window.location.href = `${wpUser}`;
        }}
           >Logout</div>*/}
 

        </div></div>:<> 
         
           </>}
 
      </div></>}
    </>
  );
}
